import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-success alert-dismissible fs-5",
  role: "alert"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-danger bg-danger alert-dismissible text-light fs-5",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.alertState === 'success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("strong", null, _toDisplayString($props.alertMessage), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.ChangeAlertState()))
          })
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.alertState === 'error')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("strong", null, _toDisplayString($props.alertMessage), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.ChangeAlertState()))
          })
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}